module.exports = __webpack_public_path__ + "static/media/9.e816e9dc.svg";